import { render } from "./caseItem.vue?vue&type=template&id=672903ac&scoped=true"
import script from "./caseItem.vue?vue&type=script&lang=js"
export * from "./caseItem.vue?vue&type=script&lang=js"

import "./caseItem.vue?vue&type=style&index=0&id=672903ac&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672903ac"]])

export default __exports__